import { render, staticRenderFns } from "./type-editor.vue?vue&type=template&id=5adb4552&scoped=true&"
import script from "./type-editor.vue?vue&type=script&lang=js&"
export * from "./type-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb4552",
  null
  
)

export default component.exports